import { produce } from 'immer';

/**
 * Helper function that creates an adapted response example with information taken from the request schema
 * for example:
 *
 * if debtor_account.id equals to '30314383523' in the request example
 * debtor_account.id will be set to '30314383523' in the response example
 *
 * In case a property is unaccessible, immer will make sure to add the property there
 * This ensures that what the user sees is consistent
 *
 * See example in [updatedResponseBasedOnRequest.test.ts](../../../../test/updatedResponseBasedOnRequest.test.ts)
 */
export const updateResponseExampleBasedOnRequestExample = (
  response: any,
  showcasedExample: any
): any => {
  return produce(response, (draft: any) => {
    // mutate the debtor account
    draft.content[
      'application/json'
    ].schema.properties.debtor_account.properties.id.example =
      showcasedExample.debtor_account?.id;
    draft.content[
      'application/json'
    ].schema.properties.debtor_account.properties.scheme_name.example =
      showcasedExample.debtor_account?.scheme_name;

    // mutate the rest
    draft.content['application/json'].schema.properties.end_to_end_id.example =
      showcasedExample?.end_to_end_id;
    draft.content['application/json'].schema.properties.amount.example =
      showcasedExample?.amount;
    draft.content['application/json'].schema.properties.currency.example =
      showcasedExample?.currency_code;
  });
};
